import React from 'react';

import { flagStyles } from '../settings';

const SvgMO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3504px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMO;
